import React from 'react';

import { Box } from '@chakra-ui/react';

export const LazySvg = ({ name, ...rest }) => {
	// name is 'user-friends'; componentName is 'FaUserFriends'
	const componentName = `Fa${name
		.split('-')
		.map((word) => word[0].toUpperCase() + word.substring(1))
		.join('')}`;
	const Component = React.lazy(() =>
		import(`@react-icons/all-files/fa/${componentName}`).then((module) => ({
			default: module[componentName],
		})),
	);
	return (
		<React.Suspense fallback={React.Fragment}>
			<Box as={Component} fill="currentColor" {...rest} />
		</React.Suspense>
	);
};
